// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__yCWZV","legacyBtn":"MutateMid_legacyBtn__drIyB"};